module.exports = __webpack_public_path__ + "img/sp_foot_ico04.e793b6fe.svg";